import Box from '@mui/material/Box';
import {
  DashboardContentOptions,
  DashboardExperience,
  EmbeddingContext,
  FrameOptions,
  createEmbeddingContext,
} from 'amazon-quicksight-embedding-sdk';
import { FC, useEffect, useRef, useState } from 'react';

type ReportItemPropsT = {
  id: string;
  route: string;
  roofTopIds: string[];
};

/**
 * https://developer.quicksight.aws/embedSample/dashboard#/get-embedding-url
 * https://aws.amazon.com/blogs/business-intelligence/level-up-your-react-app-with-amazon-quicksight-how-to-embed-your-dashboard-for-anonymous-access/
 * Creates an iframe that receives a signed AWS URL to display a dashboard. To add more options or customizations, refer to the documentation above.
 */
export const ReportItem: FC<ReportItemPropsT> = ({ id, route, roofTopIds }) => {
  const dashboardRef = useRef<any>();
  const [embeddedDashboard, setEmbeddedDashboard] = useState<DashboardExperience | null>(null);
  const [embeddingContext, setEmbeddingContext] = useState<EmbeddingContext | null>(null);

  const createContext = async () => {
    const context = await createEmbeddingContext();
    setEmbeddingContext(context);
  };

  useEffect(() => {
    if (route) {
      createContext();
    }
  }, [route]);

  const embed = async () => {
    if (dashboardRef.current) {
      dashboardRef.current.innerHTML = '';
    }

    const frameOptions: FrameOptions = {
      url: route,
      container: dashboardRef.current,
    };
    const contentOptions: DashboardContentOptions = {
      parameters: [
        {
          Name: 'rooftopids',
          Values: roofTopIds,
        },
      ],
      toolbarOptions: {
        export: true,
        undoRedo: true,
        reset: true,
      },
    };

    const newEmbeddedDashboard = await embeddingContext!.embedDashboard(
      frameOptions,
      contentOptions
    );
    setEmbeddedDashboard(newEmbeddedDashboard);
  };

  useEffect(() => {
    if (embeddingContext) {
      embed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [embeddingContext]);

  useEffect(() => {
    if (embeddedDashboard) {
      embeddedDashboard.navigateToDashboard(id, {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return <Box sx={{ flexGrow: 1, height: '100%' }} ref={dashboardRef}></Box>;
};
